<template>
  <DatatableReportV3
    ref="datatable"
    download-url="/transactions"
    title="Payments"
    :source="source"
    :config="config"
    :filters="filters"
    @draw-complete="onDrawComplete"
  />
</template>

<script>
import { customerClassificationColumns } from "@/lib/customerTypes";

import CONSTANTS from "@/Constants";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";
import PaymentActionsContextMenu from "./PaymentsActionsContextMenu.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      voidTransactionID: null,
      config: {
        responsive: true,
        order: [[0, "desc"]],
        columns: [
          {
            data: "transaction_date",
            title: "Date",
            filterName: "created_at",
            responsivePriority: 4
          },
          { data: "invoice", responsivePriority: 2 },
          ...customerClassificationColumns(),
          { data: "customer", responsivePriority: 1 },
          { data: "customer_email", title: "Email", responsivePriority: 10 },
          { data: "customer_phone", title: "Phone", responsivePriority: 9 },
          { data: "job", responsivePriority: 11 },
          {
            data: "department",
            filterName: "department_id",
            responsivePriority: 12
          },
          {
            data: "receiver",
            title: "Received By",
            filterName: "transaction_received_by",
            orderable: false,
            searchable: false,
            responsivePriority: 13
          },
          {
            data: "transaction_type",
            title: "Method",
            responsivePriority: 7
          },
          {
            data: "entry_method",
            title: "Entry Method",
            responsivePriority: 14
          },
          {
            data: "status",
            title: "Status",
            responsivePriority: 5
          },
          {
            data: "processor_name",
            title: "Processor",
            searchable: false,
            responsivePriority: 15
          },
          {
            data: "amount_cents",
            title: "Amount",
            className: "text-right",
            searchable: false,
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.total,
            responsivePriority: 3
          },
          {
            data: "txn_type",
            filterName: "txn_type",
            className: "txn-type-field",
            searchable: false,
            title: "Type",
            responsivePriority: 8
          },
          {
            data: "reconciled",
            title: "Completed",
            className: "text-center",
            searchable: false,
            responsivePriority: 6
          },
          {
            data: "processor_tx_id",
            title: "Details",
            orderable: false,
            responsivePriority: 16
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            className: "text-center th-no-text",
            searchable: false
          },
          {
            data: "processor_tx_id_for_modal",
            visible: false,
            responsivePriority: 17
          }
        ],
        vueComponents: [
          {
            rootId: "payments-context-menu-vue",
            component: PaymentActionsContextMenu,
            options: {
              store
            }
          }
        ]
      }
    };
  },
  mounted() {
    // Delegated rather than bound per draw: on a phone the Completed switch can
    // sit in a Responsive child row, which is an HTML copy made after the draw.
    $(this.$el).on("change.reconciled", ".reconciled-checkbox", (e) => {
      const transaction_id = $(e.currentTarget).data("id");
      this.updateReconciled(transaction_id, e.currentTarget.checked);
    });
  },
  beforeUnmount() {
    $(this.$el).off("change.reconciled");
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.refreshTable();
    },
    onDrawComplete() {
      // Handle void modal link
      $(".void-modal-toggle")
        .off("click")
        .on("click", (e) => {
          this.voidTransactionID = $(e.target).data("transactionId");
          const transactionType = $(e.target).data("transactionType");
          const externalSystemWarningTypes = ["card", "external"];
          if (externalSystemWarningTypes.includes(transactionType)) {
            $(".external-warning-message").show();
          } else {
            $(".external-warning-message").hide();
          }
          $("#void_modal").modal("show");
        });

      // Handle void modal submit
      $("#void_modal").on("shown.bs.modal", () => {
        $(".void-modal-submit-btn")
          .off("click")
          .on("click", () => {
            this.updateVoided();
          });
      });
    },
    updateReconciled(transaction_id, reconciled_status) {
      $.ajax(`${window.location.pathname}/${transaction_id}`, {
        method: "PUT",
        dataType: "json",
        data: {
          transaction: { reconciled: reconciled_status }
        },
        success: () => {
          const status = reconciled_status ? "completed" : "incomplete";
          window.notify.success(`Payment marked as ${status}.`);
          this.refreshTable();
        },
        error: (e) => {
          window.notify.error(
            (e.responseJSON || {}).message || "Unable to update payment status."
          );
        }
      });
    },
    updateVoided() {
      $.ajax(`${window.location.pathname}/${this.voidTransactionID}`, {
        method: "PUT",
        dataType: "json",
        data: {
          transaction: { voided: true }
        },
        success: () => {
          $("#void_modal").modal("hide");
          window.notify.success("Transaction voided successfully!");
          this.voidTransactionID = null;
          this.refreshTable();
        },
        error: (e) => {
          window.notify.error(
            (e.responseJSON || {}).message || "Unable to void transaction."
          );
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
